import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "payment-invalid-status"
}
const _hoisted_2 = { class: "body-text-bold error-text" }
const _hoisted_3 = { class: "body-text-bold" }
const _hoisted_4 = {
  key: 1,
  class: "payment-status-page"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "payment-status-page-info" }
const _hoisted_7 = { class: "section-title multiple-stars" }
const _hoisted_8 = { class: "title-text" }
const _hoisted_9 = { class: "body-text-bold primary-text" }

import { onMounted, ref } from 'vue';
import { Order, Product } from '@/types';
import axios from 'axios';
import router from '@/router';
import __ from '@/translate';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentSuccessPage',
  setup(__props) {

const product = ref<Product | null>(null);
const order = ref<Order | null>(null);
const paymentFailed = ref(false);

onMounted(async () => {
  const query = router.currentRoute.value.query;
  const params = router.currentRoute.value.params;
  const currentRouteName = router.currentRoute.value.name;

  if (!params.uuid) {
    router.push({ name: 'NotFound' });
    return;
  }

  if (currentRouteName === 'PaymentSuccessPage') {
    if (!query.payment_intent_client_secret) {
      router.push({ name: 'NotFound' });
      return;
    }
    await getOrder();
    if (!order.value?.paymentSuccessful) {
      paymentFailed.value = true;
      return;
    }
    await getProduct();
  } else if (currentRouteName === 'OrderSuccessPage') {
    await getOrder();

    if (order.value?.paymentMethod !== 'delivery') {
      router.push({ name: 'NotFound' });
      return;
    }

    await getProduct();
  } else {
    router.push({ name: 'NotFound' });
  }
});

function getOrder() {
  return axios
    .get(`/api/orders/${router.currentRoute.value.params.uuid}`)
    .then((response) => {
      order.value = response.data;
    })
    .catch(() => {
      router.push({ name: 'NotFound' });
    });
}

function getProduct() {
  return axios
    .get(`/api/products/${order.value?.productId}`)
    .then((response) => {
      product.value = response.data;
    })
    .catch(() => {
      router.push({ name: 'NotFound' });
    });
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (paymentFailed.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(__)('payment_failed_title')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(__)('payment_failed_subtitle')), 1)
      ]))
    : (product.value && order.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: product.value.imageUrl,
            class: "payment-status-page-image"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(__)('payment_success_title')), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(__)('payment_success_subtitle')) + " " + _toDisplayString(product.value.name) + "!", 1),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "body-text" }, null, -1)),
            _createVNode(_component_router_link, {
              to: {
          name: 'LandingPage',
        },
              class: "payment-status-page-info-back"
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "arrow left-arrow" }, null, -1)),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(__)('back_to_home_screen')), 1)
              ]),
              _: 1,
              __: [0]
            })
          ])
        ]))
      : _createCommentVNode("", true)
}
}

})